import DefaultFileUpload from "./default-file-upload";

export default { DefaultFileUpload };
